import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41d482e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Allow participant", -1))
const _hoisted_3 = {
  key: 0,
  class: "toggle-mobile"
}
const _hoisted_4 = {
  key: 1,
  class: "toggle-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleWithText = _resolveComponent("ToggleWithText")!
  const _component_Toggle = _resolveComponent("Toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isMobileScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listToggle, (item) => {
            return (_openBlock(), _createBlock(_component_ToggleWithText, {
              title: item,
              isDisabled: _ctx.isDisabled
            }, null, 8, ["title", "isDisabled"]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobileScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listToggle, (item, key) => {
            return (_openBlock(), _createBlock(_component_Toggle, {
              class: "toggle-item",
              id: key,
              text: item,
              isDisabled: _ctx.isDisabled
            }, null, 8, ["id", "text", "isDisabled"]))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}